import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";

function ListadoKillers() {
  const { user } = useContext(AuthContext);
  const URL_KILLERS = process.env.REACT_APP_URL_KILLERS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;

  const [killers, setKillers] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [filterGrupo, setFilterGrupo] = useState("");

  // Edit state
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState("");
  const [montoEdit, setMontoEdit] = useState(0);
  const [fechaInicioEdit, setFechaInicioEdit] = useState("");
  const [fechaFinEdit, setFechaFinEdit] = useState("");

  // Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(URL_KILLERS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allKillers = response.data;
        let arrayTabla = allKillers
          .sort((a, b) => (a.fechaInicio < b.fechaInicio ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.articulos?.[0]?.nombre || a.articulos?.[0]?.codigo || "Sin nombre",
              monto: a.monto,
              fechaInicio: a.fechaInicio,
              fechaFin: a.fechaFin,
              gruposId: a.grupos?._id || "",
              gruposNombre: a.grupos?.name || "—",
            };
          })
          .filter((el) => el != null);

        setComments(arrayTabla);
        setKillers(arrayTabla);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user]);

  useEffect(() => {
    axios.get(URL_GRUPOS, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then((res) => setGrupos(res.data)).catch(console.log);
  }, []);

  const headers = [
    { name: "Artículo", field: "nombre", sortable: true },
    { name: "Grupo", field: "gruposNombre", sortable: true },
    { name: "Monto ($)", field: "monto", sortable: false },
    { name: "Fecha Inicio", field: "fechaInicio", sortable: true },
    { name: "Fecha Fin", field: "fechaFin", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter((c) =>
        c.nombre.toLowerCase().includes(search.toLowerCase()) ||
        c.gruposNombre.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (filterGrupo) {
      computedComments = computedComments.filter((c) => c.gruposId === filterGrupo);
    }

    setTotalItems(computedComments.length);

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  function jalaInfo(id, monto, fechaInicio, fechaFin) {
    setIdEdit(id);
    setMontoEdit(monto);
    setFechaInicioEdit(fechaInicio);
    setFechaFinEdit(fechaFin);
    toggleEdit();
  }

  const editKiller = (event) => {
    event.preventDefault();
    axios
      .patch(
        `${URL_KILLERS}/${idEdit}`,
        {
          monto: parseFloat(montoEdit),
          fechaInicio: fechaInicioEdit,
          fechaFin: fechaFinEdit,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Edit Killer",
            detalle: `ID: ${idEdit} / Monto: ${montoEdit}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data}`,
        });
        console.log(error);
      });
  };

  function eliminarKiller(idKiller) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se eliminara el Killer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${URL_KILLERS}/${idKiller}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Eliminar Killer",
                detalle: `ID: ${idKiller}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Eliminado!", "El Killer ha sido eliminado.", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          {/* Toolbar */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px 6px" }}>
            <h4 style={{ margin: 0, fontWeight: 700, color: "#1e3a8a" }}>⚡ Killers Walmart</h4>
            <div style={{ display: "flex", gap: 8 }}>
              <Button size="sm" color="success" href="/KillersCreate">+ Nuevo Killer</Button>
              <Button size="sm" href="/MenuVentas" className="btn btn-danger">← Regresar</Button>
            </div>
          </div>

          {/* Search */}
          <div style={block}>
            <div style={sec}>🔍 Filtros</div>
            <Row>
              <Col md={3}>
                <Label>Grupo</Label>
                <Input type="select" value={filterGrupo} onChange={(e) => { setFilterGrupo(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos los grupos</option>
                  {grupos.sort((a,b) => a.name > b.name ? 1 : -1).map((g) => (
                    <option key={g._id} value={g._id}>{g.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={4}>
                <Label>Buscar</Label>
                <Search onSearch={(value) => { setSearch(value); setCurrentPage(1); }} />
              </Col>
            </Row>
          </div>

          {/* Pagination + badge */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
            <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontWeight: 700, fontSize: "0.85rem" }}>
              {commentsData.length} killers
            </span>
          </div>

          <Table size="sm" bordered striped className="table-responsive-xl" style={{ fontSize: "0.82rem" }}>
            <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order })} />
            <tbody>
              {commentsData.map((c) => (
                <tr key={c._id}>
                  <td>{c.nombre}</td>
                  <td>{c.gruposNombre}</td>
                  <td>{new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 2 }).format(c.monto)}</td>
                  <td>{c.fechaInicio}</td>
                  <td>{c.fechaFin}</td>
                  <td>
                    <Button color="info" size="sm" onClick={() => jalaInfo(c._id, c.monto, c.fechaInicio, c.fechaFin)}>
                      <i className="far fa-edit"></i>
                    </Button>{" "}
                    <Button size="sm" color="danger" onClick={() => eliminarKiller(c._id)}>
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
          </div>
        </div>
      ) : (
        <div className="card col-12">
          <h3 align="center" style={{ padding: 20, color: "#dc2626" }}>Acceso Denegado</h3>
        </div>
      )}

      {/* Modal Editar */}
      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}><h4>Editar Killer</h4></ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Monto</Label>
          <Input type="number" value={montoEdit} onChange={(e) => setMontoEdit(e.target.value)} />
          <Label className="mr-sm-2">Fecha Inicio</Label>
          <Input type="date" value={fechaInicioEdit} onChange={(e) => setFechaInicioEdit(e.target.value)} />
          <Label className="mr-sm-2">Fecha Fin</Label>
          <Input type="date" value={fechaFinEdit} onChange={(e) => setFechaFinEdit(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={editKiller}>Guardar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoKillers;
